import * as Sentry from "@sentry/browser";
import type React from "react";
import { Component, type ReactNode } from "react";

import ErrorPage from "./components/error-page";
import type { ILenderUser } from "./features/users/types";

interface SentryBoundaryProps {
  children: ReactNode;
  lenderInfo?: ILenderUser | null;
}

interface SentryBoundaryState {
  eventId: string | null;
  hasError: boolean;
}

class SentryBoundary extends Component<
  SentryBoundaryProps,
  SentryBoundaryState
> {
  constructor(props: SentryBoundaryProps) {
    super(props);
    this.state = { eventId: null, hasError: false };
  }

  static getDerivedStateFromError(): Partial<SentryBoundaryState> {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras({ ...errorInfo });

      if (this.props.lenderInfo?.id) {
        scope.setUser({ id: String(this.props.lenderInfo.id) });
      }
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage sentryEventId={this.state.eventId} is404error={false} />
      );
    }

    // when there's not an error, render children untouched
    return this.props.children;
  }
}

export default SentryBoundary;
